<template>
  <div class="history__modal">
    <div class="history__modal-header">
      <h4 class="history__modal-title">היסטוריה סטטוסים</h4>
      <button
        class="history__modal-close-button"
        @click.stop="$emit('closeHistory')"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 4L3.99994 12.0001"
            stroke="#8E9EBB"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M4 4L12.0001 12.0001"
            stroke="#8E9EBB"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>
    <div class="history__modal-list">
      <div v-for="his in history" :key="his.id">
        <div class="history-card green" v-if="his.status == 3">
          <div class="status-lesson-block">
            <div class="exel-status">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.375 15V6C4.375 5.44772 4.82272 5 5.375 5L8.875 5C10.5319 5 11.875 6.34315 11.875 8V11.25"
                  stroke="#5A6F95"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M8.125 9.375V15H12.625C14.2819 15 15.625 13.6569 15.625 12V5"
                  stroke="#5A6F95"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>

            <div class="history-card__status">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="14"
                viewBox="0 0 20 14"
                fill="none"
              >
                <path
                  d="M19 9H1.5L5 13M1 5H19L15.5 1"
                  stroke="#24B33C"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              התקיים
            </div>
          </div>
          <div class="history-card__header">
            <div class="history-card__title" v-if="his.fill_user">
              {{ `${his.fill_user.name} ${his.fill_user.last_name} ` }}
            </div>
            <div class="history-card__date">
              {{ formatDateTime(his.created_at) }}
            </div>
          </div>
          <div v-if="his.confirmed">
            <div class="history-card__list">
              <div
                class="history-card__list-item green"
                v-if="his.confirmed == 1"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.5916 9.59996V6.39998C12.5916 5.07451 12.5187 4 11.1952 4L8 11.2V19.9999H17.282C18.0786 20.0089 18.7601 19.4288 18.8796 18.6399L19.9819 11.44C20.0522 10.9758 19.9155 10.5042 19.6079 10.15C19.3004 9.79574 18.853 9.59465 18.3843 9.59996H12.5916Z"
                    stroke="#29CC44"
                    stroke-width="1.5"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M8 11.0003H5.864C4.92681 10.9835 4.12564 11.7695 4 12.7099V18.3798C4.12564 19.3202 4.92681 20.0165 5.864 19.9997H8V11.0003Z"
                    stroke="#29CC44"
                    stroke-width="1.5"
                    stroke-linejoin="round"
                  />
                </svg>
                <!-- {{ confirm.fill_user.name }} -->
                <!-- <span>{{ confirm.date }}</span> -->
              </div>
              <div
                class="history-card__list-item red"
                v-if="his.confirmed == 2"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.5916 14.4V17.6C12.5916 18.9255 12.5187 20 11.1952 20L8 12.8V4.0001H17.282C18.0786 3.99108 18.7601 4.57124 18.8796 5.36009L19.9819 12.56C20.0522 13.0242 19.9155 13.4958 19.6079 13.85C19.3004 14.2043 18.853 14.4054 18.3843 14.4H12.5916Z"
                    stroke="#FF5040"
                    stroke-width="1.5"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M8 12.9997H5.864C4.92681 13.0165 4.12564 12.2305 4 11.2901V5.62025C4.12564 4.67979 4.92681 3.98352 5.864 4.0003H8V12.9997Z"
                    stroke="#FF5040"
                    stroke-width="1.5"
                    stroke-linejoin="round"
                  />
                </svg>
                <!-- {{ confirm.fill_user.full_name }} -->
                <!-- <span>{{ confirm.date }}</span> -->
              </div>
            </div>
          </div>
        </div>
        <div class="history-card green" v-if="his.status === 2">
          <div class="status-lesson-block">
            <div class="exel-status">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.375 15V6C4.375 5.44772 4.82272 5 5.375 5L8.875 5C10.5319 5 11.875 6.34315 11.875 8V11.25"
                  stroke="#5A6F95"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M8.125 9.375V15H12.625C14.2819 15 15.625 13.6569 15.625 12V5"
                  stroke="#5A6F95"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div class="history-card__status">התקיים</div>
          </div>
          <div class="history-card__header">
            <div class="history-card__title" v-if="his.fill_user">
              {{ `${his.fill_user.name} ${his.fill_user.last_name} ` }}
            </div>
            <div class="history-card__date">
              {{ formatDateTime(his.created_at) }}
            </div>
          </div>
          <div v-if="his.confirmed">
            <div class="history-card__list">
              <div
                class="history-card__list-item green"
                v-if="his.confirmed == 1"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.5916 9.59996V6.39998C12.5916 5.07451 12.5187 4 11.1952 4L8 11.2V19.9999H17.282C18.0786 20.0089 18.7601 19.4288 18.8796 18.6399L19.9819 11.44C20.0522 10.9758 19.9155 10.5042 19.6079 10.15C19.3004 9.79574 18.853 9.59465 18.3843 9.59996H12.5916Z"
                    stroke="#29CC44"
                    stroke-width="1.5"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M8 11.0003H5.864C4.92681 10.9835 4.12564 11.7695 4 12.7099V18.3798C4.12564 19.3202 4.92681 20.0165 5.864 19.9997H8V11.0003Z"
                    stroke="#29CC44"
                    stroke-width="1.5"
                    stroke-linejoin="round"
                  />
                </svg>
                <!-- {{ confirm.fill_user.full_name }}
                <span>{{ formatDateTime(his.created_at) }}</span> -->
              </div>
              <div
                class="history-card__list-item red"
                v-if="his.confirmed == 2"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.5916 14.4V17.6C12.5916 18.9255 12.5187 20 11.1952 20L8 12.8V4.0001H17.282C18.0786 3.99108 18.7601 4.57124 18.8796 5.36009L19.9819 12.56C20.0522 13.0242 19.9155 13.4958 19.6079 13.85C19.3004 14.2043 18.853 14.4054 18.3843 14.4H12.5916Z"
                    stroke="#FF5040"
                    stroke-width="1.5"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M8 12.9997H5.864C4.92681 13.0165 4.12564 12.2305 4 11.2901V5.62025C4.12564 4.67979 4.92681 3.98352 5.864 4.0003H8V12.9997Z"
                    stroke="#FF5040"
                    stroke-width="1.5"
                    stroke-linejoin="round"
                  />
                </svg>
                <!-- {{ confirm.fill_user.full_name }} -->
                <!-- <span>{{ formatDateTime(his.created_at) }}</span> -->
              </div>
            </div>
          </div>
        </div>
        <div class="history-card red" v-if="his.status == 4">
          <div class="status-lesson-block">
            <div class="exel-status">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.375 15V6C4.375 5.44772 4.82272 5 5.375 5L8.875 5C10.5319 5 11.875 6.34315 11.875 8V11.25"
                  stroke="#5A6F95"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M8.125 9.375V15H12.625C14.2819 15 15.625 13.6569 15.625 12V5"
                  stroke="#5A6F95"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div class="history-card__status">לא התקיים'</div>
          </div>
          <div class="history-card__header">
            <div class="history-card__title" v-if="his.fill_user">
              {{ `${his.fill_user.name} ${his.fill_user.last_name} ` }}
            </div>
            <div class="history-card__date">
              {{ formatDateTime(his.created_at) }}
            </div>
          </div>
          <div v-if="his.confirmed">
            <div class="history-card__list">
              <div
                class="history-card__list-item green"
                v-if="his.confirmed == 1"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.5916 9.59996V6.39998C12.5916 5.07451 12.5187 4 11.1952 4L8 11.2V19.9999H17.282C18.0786 20.0089 18.7601 19.4288 18.8796 18.6399L19.9819 11.44C20.0522 10.9758 19.9155 10.5042 19.6079 10.15C19.3004 9.79574 18.853 9.59465 18.3843 9.59996H12.5916Z"
                    stroke="#29CC44"
                    stroke-width="1.5"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M8 11.0003H5.864C4.92681 10.9835 4.12564 11.7695 4 12.7099V18.3798C4.12564 19.3202 4.92681 20.0165 5.864 19.9997H8V11.0003Z"
                    stroke="#29CC44"
                    stroke-width="1.5"
                    stroke-linejoin="round"
                  />
                </svg>
                <!-- {{ confirm.fill_user.full_name }}
                <span>{{ formatDateTime(his.created_at) }}</span> -->
              </div>
              <div
                class="history-card__list-item red"
                v-if="his.confirmed == 2"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.5916 14.4V17.6C12.5916 18.9255 12.5187 20 11.1952 20L8 12.8V4.0001H17.282C18.0786 3.99108 18.7601 4.57124 18.8796 5.36009L19.9819 12.56C20.0522 13.0242 19.9155 13.4958 19.6079 13.85C19.3004 14.2043 18.853 14.4054 18.3843 14.4H12.5916Z"
                    stroke="#FF5040"
                    stroke-width="1.5"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M8 12.9997H5.864C4.92681 13.0165 4.12564 12.2305 4 11.2901V5.62025C4.12564 4.67979 4.92681 3.98352 5.864 4.0003H8V12.9997Z"
                    stroke="#FF5040"
                    stroke-width="1.5"
                    stroke-linejoin="round"
                  />
                </svg>
                <!-- {{ confirm.fill_user.full_name }} -->
                <!-- <span>{{ formatDateTime(his.created_at) }}</span> -->
              </div>
            </div>
          </div>
        </div>
        <div class="history-card blue" v-if="his.status == 1">
          <div class="history-card__status">מתוכנן</div>
          <div class="history-card__header">
            <div class="history-card__title" v-if="his.fill_user">
              {{ `${his.fill_user.name} ${his.fill_user.last_name} ` }}
            </div>
            <div class="history-card__date">
              {{ formatDateTime(his.created_at) }}
            </div>
          </div>
        </div>
        <div class="history-card grey" v-if="his.status == 5">
          <div class="status-lesson-block">
            <div class="exel-status">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.375 15V6C4.375 5.44772 4.82272 5 5.375 5L8.875 5C10.5319 5 11.875 6.34315 11.875 8V11.25"
                  stroke="#5A6F95"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M8.125 9.375V15H12.625C14.2819 15 15.625 13.6569 15.625 12V5"
                  stroke="#5A6F95"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div class="history-card__status">בוטל</div>
          </div>
          <div class="history-card__header">
            <div class="history-card__title" v-if="his.fill_user">
              {{ `${his.fill_user.name} ${his.fill_user.last_name} ` }}
            </div>
            <div class="history-card__date">
              {{ formatDateTime(his.created_at) }}
            </div>
          </div>
          <div v-if="his.confirmed">
            <div class="history-card__list">
              <div
                class="history-card__list-item green"
                v-if="his.confirmed == 1"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.5916 9.59996V6.39998C12.5916 5.07451 12.5187 4 11.1952 4L8 11.2V19.9999H17.282C18.0786 20.0089 18.7601 19.4288 18.8796 18.6399L19.9819 11.44C20.0522 10.9758 19.9155 10.5042 19.6079 10.15C19.3004 9.79574 18.853 9.59465 18.3843 9.59996H12.5916Z"
                    stroke="#29CC44"
                    stroke-width="1.5"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M8 11.0003H5.864C4.92681 10.9835 4.12564 11.7695 4 12.7099V18.3798C4.12564 19.3202 4.92681 20.0165 5.864 19.9997H8V11.0003Z"
                    stroke="#29CC44"
                    stroke-width="1.5"
                    stroke-linejoin="round"
                  />
                </svg>
                <!-- {{ confirm.fill_user.full_name }}
                <span>{{ formatDateTime(his.created_at) }}</span> -->
              </div>
              <div
                class="history-card__list-item red"
                v-if="his.confirmed == 2"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.5916 14.4V17.6C12.5916 18.9255 12.5187 20 11.1952 20L8 12.8V4.0001H17.282C18.0786 3.99108 18.7601 4.57124 18.8796 5.36009L19.9819 12.56C20.0522 13.0242 19.9155 13.4958 19.6079 13.85C19.3004 14.2043 18.853 14.4054 18.3843 14.4H12.5916Z"
                    stroke="#FF5040"
                    stroke-width="1.5"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M8 12.9997H5.864C4.92681 13.0165 4.12564 12.2305 4 11.2901V5.62025C4.12564 4.67979 4.92681 3.98352 5.864 4.0003H8V12.9997Z"
                    stroke="#FF5040"
                    stroke-width="1.5"
                    stroke-linejoin="round"
                  />
                </svg>
                <!-- {{ confirm.fill_user.full_name }} -->
                <!-- <span>{{ formatDateTime(his.created_at) }}</span> -->
              </div>
            </div>
          </div>
        </div>
        <div class="history-card yellow" v-if="his.status == 6">
          <div class="status-lesson-block">
            <div class="exel-status">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.375 15V6C4.375 5.44772 4.82272 5 5.375 5L8.875 5C10.5319 5 11.875 6.34315 11.875 8V11.25"
                  stroke="#5A6F95"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M8.125 9.375V15H12.625C14.2819 15 15.625 13.6569 15.625 12V5"
                  stroke="#5A6F95"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div class="history-card__status">מועד עבר</div>
          </div>
          <div class="history-card__header">
            <div class="history-card__title" v-if="his.fill_user">
              {{ `${his.fill_user.name} ${his.fill_user.last_name} ` }}
            </div>
            <div class="history-card__date">
              {{ formatDateTime(his.created_at) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HistoryModals',
  props: {
    history: {
      type: Array
    }
  },
  methods: {
    formatDateTime(inputDate) {
      const date = new Date(inputDate);
      if (isNaN(date.getTime())) {
        return 'Invalid Date'; // Проверка на неверную дату
      }

      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');

      return `${day}.${month}.${year} / ${hours}:${minutes}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.exel-status {
  padding-right: 8px;
}
.status-lesson-block {
  display: flex;
  align-items: stretch;
  /* gap: 4px; */
  padding-left: 4px;
  /* background: #ddffe3; */
  border-radius: 12px;
  flex-direction: row-reverse;
  justify-content: flex-end;
}
// .lessons__status-wrap {
//   width: 100%;
// }
.exel-status {
  cursor: pointer;
  background: #ddffe3;
  padding-left: 8px;
  position: relative;
  z-index: 0;
  left: 8px;
  height: 24px;
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
}
.exel-status img {
  padding-right: 12px;
}
.history-card__status {
  position: relative;
}
.history__modal {
  position: absolute;
  top: 45px;
  left: 24px;
  z-index: 20;
  background: #f7f8fa;
  max-width: 325px;
  width: 100%;
  /* Sub Grey */

  border: 0.75px solid #ebeef5;
  /* Level 5 */

  box-shadow: 0px 8px 20px rgba(56, 69, 93, 0.1),
    0px 4px 9px rgba(56, 69, 93, 0.08), 0px 2px 5px rgba(56, 69, 93, 0.0596107),
    0px 1px 3px rgba(56, 69, 93, 0.05),
    0px 0.598509px 1.5px rgba(56, 69, 93, 0.0403893),
    0px 0.249053px 1px rgba(56, 69, 93, 0.03);
  border-radius: 16px;
  padding-bottom: 24px;
  &-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 16px 0 16px;
  }
  &-close-button {
    width: 24px;
    height: 24px;
    border: none;
    background-color: transparent;
    padding: 0;
    cursor: pointer;
  }
  &-list {
    height: 100%;
    max-height: 400px;
    overflow-y: auto;
    display: grid;
    gap: 8px;
    padding: 16px;
    &::-webkit-scrollbar {
      width: 4px;
      border-radius: 2px;
    }
    &::-webkit-scrollbar-track {
      background-color: #f7f8fa;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #cfd3de;
      border-radius: 2px;
    }
  }
}

.history-card {
  background: #ffffff;
  box-shadow: 0px 4px 8px rgba(90, 111, 149, 0.16);
  border-radius: 12px;
  padding: 16px;
  position: relative;
  &.red {
    &::before {
      background: #ff5040;
    }
    .history-card {
      &__status {
        background: #ff5040;
      }
    }
  }
  &.yellow {
    &::before {
      background: #ffcc33;
    }
    .history-card {
      &__status {
        background: #ffcc33;
        margin-bottom: 0;
      }
      &__title {
        display: none;
      }
      &__date {
        position: absolute;
        top: 50%;
        left: 16px;
        transform: translateY(-50%);
      }
      &__header {
        margin-bottom: 0;
      }
    }
  }
  &.green {
    &::before {
      background: #29cc44;
    }
    .history-card {
      &__status {
        background: #29cc44;
      }
    }
  }
  &.grey {
    &::before {
      background: #cfd3de;
    }
    .history-card {
      &__status {
        background: #cfd3de;
      }
    }
  }
  &.blue {
    &::before {
      background: #e5f2ff;
    }
    .history-card {
      &__status {
        background: #e5f2ff;
        color: #409fff;
      }
    }
  }
  &.grey {
    &::before {
      background: #cfd3de;
    }
    .history-card {
      &__status {
        background: #cfd3de;
      }
    }
  }
  &::before {
    content: '';
    position: absolute;
    top: 16px;
    right: 0;
    width: 4px;
    height: calc(100% - 32px);
    border-radius: 8px 0 0 8px;
  }
  &__status {
    width: 104px;
    height: 24px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.01em;
    color: #f7f8fa;
    margin-bottom: 16px;
  }
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  &__title {
    font-size: 16px;
    line-height: 24px;
    color: #38455d;
  }
  &__date {
    font-size: 10px;
    line-height: 12px;
    color: #929baa;
  }
  &__list {
    display: grid;
    gap: 8px;
    &:first-child {
      .history-card {
        &__list-item {
          &:first-child {
            margin-top: 16px;
          }
        }
      }
    }
  }
  &__list-item {
    padding: 8px;
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 500;
    font-size: 14px;
    line-height: 125%;
    color: #38455d;
    border-radius: 12px;
    text-align: right;
    svg {
      flex-shrink: 0;
    }
    &:first-child {
      margin-top: 8px;
    }
    &.green {
      background: #e6ffea;
    }
    &.red {
      background: #ffe8e6;
    }
    span {
      flex-grow: 1;
      text-align: left;
      font-size: 10px;
      line-height: 12px;
      color: #929baa;
      text-align: left;
      flex-shrink: 0;
    }
  }
}
</style>
